import { HttpResponse } from '@angular/common/http';

export interface TcsServerResponseError {
  message: string;
  code: number;
}
export type TcsServerResponseStatus = 'Succeeded' | 'Failed';
export interface TcsServerResponse {
  data?: any;
  status: TcsServerResponseStatus;
  errors: TcsServerResponseError[];
}

export function toTcsServerResponse(response: HttpResponse<TcsServerResponse>) {
  return 'body' in response &&
    response.body != null &&
    'data' in response.body &&
    'status' in response.body &&
    'errors' in response.body
    ? {
        data:
          response.body.data != null && JSON.stringify(response.body.data) === '{}'
            ? undefined
            : response.body.data,
        status: response.body.status as TcsServerResponseStatus,
        errors: response.body.errors as TcsServerResponseError[],
      }
    : {
        status: 'Failed' as TcsServerResponseStatus,
        errors: [
          { message: `${response.statusText} with unknown server response`, code: response.status },
        ],
      };
}
